<template>
<v-layout row>
  <div>
    <confirm ref="confirm"></confirm>
    <loader v-model=statusval.loading></loader>
    <arksnackbar v-model="statusval"></arksnackbar>
  </div>
  <v-flex xs12 sm12>
    <v-card>
      <v-toolbar color="light-blue">

        <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
        <v-btn fab small color="cyan accent-2" bottom left absolute @click="insertKalem()">
          <v-icon>add</v-icon>
        </v-btn>

        <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field ref="aramatext" solo hide-details v-model="aranacak" :label="this.$t('Search')" append-outer-icon="refresh" append-icon="search" @click:append-outer="yenile();" v-on:keyup.13="yenile();"></v-text-field>

      </v-toolbar>

      <slot name="toolbarbottom"><br></slot>

        <!-- Begin Data Table ************************************************************************************-->
        <div class="flex md12">
          <v-data-table :headers="tableheaders" :items="tableitems" hide-actions class="elevation-1">

            <template slot="items" slot-scope="props">
              <tr>
                <slot v-bind:item="props.item">
                  <td v-for="tableheader in tableheaders" :key="tableheader.id" v-if="tableheader.value!='islemsutunu'">
                    <template v-if="tableheader.value2!=undefined">
                      {{ props.item[tableheader.value][tableheader.value2]}}
                    </template>
                    <template v-else>
                      {{props.item[tableheader.value]}}
                    </template>
                  </td>
                </slot>

                <td class="justify-center layout px-0">
                  <v-btn icon class="mx-0" @click="editKalem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteKalem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

          </v-data-table>
        </div>
        <!-- End Data Table *************************************************************************************** -->

    </v-card>

    <v-fab-transition>
      <v-btn fab small color="cyan accent-2" bottom right="" absolute @click="insertKalem()">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

  </v-flex>


  <customdialog v-model="dialog" :title="getTitle()">
    <slot name="dialogmain" v-bind:item="val"></slot>

    <template slot="btn">
      <v-btn color="primary" flat @click="dialogOk">{{$t("save_button")}}</v-btn>
    </template>

  </customdialog>

</v-layout>
</template>

<script>
import confirm from "@/components/app/coper/comp/confirm.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

import tool from "../tools";

export default {
  props: ["tableitems", "tableheaders", "title", "item", "status"],
  data() {
    return {
      aranacak: "",
      dialog: false,
      dialogStatus: null,
      fitem: null
    };
  },
  components: {
    confirm,
    loader,
    arksnackbar,
    customdialog
  },

  computed: {
    val: {
      get: function () {
        if (this.fitem == null) return this.item;
        else return this.fitem;
      },
      set: function (newValue) {
        this.fitem = newValue;
      }
    },

    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      }
    }
  },

  methods: {
    yenile: yenile,
    editKalem: editKalem,
    insertKalem: insertKalem,

    deleteKalem: deleteKalem,
    dialogOk: dialogOk,
    getTitle() {
      if (this.dialogStatus == "edit") {
        return this.$t('Edit-Record')
      } else if (this.dialogStatus == "insert") {
        return this.$t('New-Record')
      }
    }
  }
};

function yenile() {
  if (this.statusval.loading == false) {
    this.statusval.loading = true;
    setTimeout(() => {
      this.$emit("kayitgetir", this.aranacak);

      this.$refs.aramatext.$el.focus();
    }, 600);
  }
}

function dialogOk() {
  this.dialog = false;

  if (this.dialogStatus == "edit") {
    this.$emit("edititem", this.val);
  } else if (this.dialogStatus == "insert") {
    this.$emit("insertitem", this.val);
  }
}

function editKalem(val) {
  this.dialogStatus = "edit";
  this.val = Object.assign({}, val);
  this.dialog = true;
}

function insertKalem() {
  this.dialogStatus = "insert";
  this.val = Object.assign({}, {});
  this.dialog = true;
}

function deleteKalem(val1) {
  this.$refs.confirm
    .open("Kayıt Sil", this.$t('Delete-the-records'), {
      color: "red",
      message: this.$t('approve-record-deletion')
    })
    .then(confirm => {
      if (confirm == true) {
        this.$emit("deleteitem", val1);
      }
    });
}
</script>
